import { useEffect, useState } from 'react';

/**
 * Keeps a closing surface mounted for `exitMs` so it can fade out instead of
 * vanishing. Returns whether to render and whether it is on its way out.
 */
export function usePresence(open: boolean, exitMs = 200): { mounted: boolean; leaving: boolean } {
  const [mounted, setMounted] = useState(open);
  useEffect(() => {
    if (open) {
      setMounted(true);
      return undefined;
    }
    const timer = window.setTimeout(() => setMounted(false), exitMs);
    return () => window.clearTimeout(timer);
  }, [open, exitMs]);
  return { mounted: open || mounted, leaving: !open && mounted };
}

export default usePresence;
